const blockedScripts = [
  { url: "https://static-tracking.klaviyo.com", category: "C0002,C0004" },
  { url: "https://ecom-app.rakutenadvertising.io/rakuten_advertising.js", category: "C0002,C0004" },
  { url: "https://ct.pinterest.com", category: "C0002,C0004" },
  { url: "https://dx.mountain.com", category: "C0002,C0004" },
  { url: "https://px.mountain.com", category: "C0002,C0004" },
  { url: "https://tr.snapchat.com", category: "C0002,C0004" },
  { url: "https://intg.snapchat.com", category: "C0002,C0004" },
];

function isCategoryAllowed(categoryString) {
  if (!window.OptanonActiveGroups) return false;

  const activeGroups = window.OptanonActiveGroups.split(",").map(cat => cat.trim());
  const requiredCategories = categoryString.split(",").map(cat => cat.trim());

  return requiredCategories.every(cat => activeGroups.includes(cat));
}

(function () {
  const originalCreateElement = document.createElement;
  const originalAppendChild = Element.prototype.appendChild;
  const originalInsertBefore = Element.prototype.insertBefore;

  function blockScript(element) {
    if (element.tagName && element.tagName.toLowerCase() === "script") {
      const scriptSrc = element.src || element.getAttribute("src");
      if (scriptSrc) {
        const blockedScript = blockedScripts.find(script => scriptSrc.includes(script.url));
        if (blockedScript) {
          element.setAttribute("data-src", scriptSrc); // Store for debugging
          element.removeAttribute("src"); // Prevent loading
          element.setAttribute("type", "text/plain"); // Prevent execution
        }
      }
    }
  }

  document.createElement = function (tagName) {
    const element = originalCreateElement.call(document, tagName);
    if (tagName.toLowerCase() === "script") {
      const originalSetAttribute = element.setAttribute;
      element.setAttribute = function (name, value) {
        if (name === "src") {
          blockScript(element);
        }
        originalSetAttribute.call(this, name, value);
      };
    }
    return element;
  };

  Element.prototype.appendChild = function (node) {
    blockScript(node);
    return originalAppendChild.call(this, node);
  };

  Element.prototype.insertBefore = function (node, refNode) {
    blockScript(node);
    return originalInsertBefore.call(this, node, refNode);
  };
})();

function OptanonWrapper() {
  blockedScripts.forEach(script => {
    if (isCategoryAllowed(script.category)) {
      const scriptElements = document.querySelectorAll(
        `script[type="text/plain"][data-src*="${script.url}"]`
      );
      scriptElements.forEach(scriptElement => {
        scriptElement.removeAttribute("type"); // Allow execution
        scriptElement.setAttribute("src", scriptElement.getAttribute("data-src")); // Restore src to trigger load
      });
    }
  });
  var $link = $(".ot-imprint-link");
  if($link?.length === 0) return;
  // Update the link text to just "Terms of Use"
  $link.text("Terms of Use");
  // Insert "and" wrapped in a span with margin-left if not already present
  if (!$link.prev().is("span.and-text")) {
    $link.before('<span class="and-text" style="margin-left:5px;">and</span> ');
  }
  // Append " and consent to our cookies." after the link text if not already present
  if (!$link.next().is("span.consent-text")) {
    $link.after('<span class="consent-text" style="margin-left:5px;"> and consent to our cookies.</span>');
  }
}
